
import { Component, Vue } from "vue-property-decorator";
import { namespace, Getter, Mutation, Action } from "vuex-class";
import { get } from "lodash";
import { UserPermissions, FeaturesList } from "@/store/types";
import NavHeader from "@/components/NavHeader.vue";
import AlarmSetupTable from "@/components/setup/alarm-setup/AlarmSetupTable.vue";

@Component({
	components: {
		"nav-header": NavHeader,
		"alarm-setup-table": AlarmSetupTable
	}
})
export default class AlarmSetup extends Vue {
	@Getter("getFeaturesList") featuresList: FeaturesList;
	@Getter("getPermissions") permissions: UserPermissions;

	public get canViewAlarmSetup() {
		return (
			get(this.featuresList, ["AlarmSetup"]) && (this.permissions.isAdmin || this.permissions.canViewSiteSetup)
		);
	}
}
